/**
 * The list of languages supported by Google Cloud Translate.
 * See https://cloud.google.com/translate/docs/languages
 *
 * Note that we are maintaining our own list of supported languages to avoid
 * additional API calls and will need to update this list as more language support
 * is added by Google.
 *
 * Note also that this list also contains ISO 639-2 (three letter) codes
 * for some languages without a 639-1 (two letter) code.
 *
 * See https://www.loc.gov/standards/iso639-2/faq.html#2 for more information.
 */
const GOOGLE_LANGUAGES = [
	'af',
	'sq',
	'am',
	'ar',
	'hy',
	'as',
	'ay',
	'az',
	'bm',
	'eu',
	'be',
	'bn',
	'bho',
	'bs',
	'bg',
	'ca',
	'ceb',
	'ny',
	'zh',
	// 'zh-CN', NOTE: alternative code for Chinese (Simplified) (zh)
	'zh-TW',
	'co',
	'hr',
	'cs',
	'da',
	'dv',
	'doi',
	'nl',
	'en',
	'eo',
	'et',
	'ee',
	'tl',
	'fi',
	'fr',
	'fy',
	'gl',
	'lg',
	'ka',
	'de',
	'el',
	'gn',
	'gu',
	'ht',
	'ha',
	'haw',
	'hi',
	'hmn',
	'hu',
	'is',
	'ig',
	'ilo',
	'id',
	'ga',
	'it',
	'ja',
	'kn',
	'kk',
	'km',
	'rw',
	'gom',
	'ko',
	'kri',
	'ku',
	'ckb',
	'ky',
	'lo',
	'la',
	'lv',
	'ln',
	'lt',
	'lb',
	'mk',
	'mai',
	'mg',
	'ms',
	'ml',
	'mt',
	'mi',
	'mr',
	'mni-Mtei',
	'lus',
	'mn',
	'my',
	'ne',
	'nso',
	'no',
	'or',
	'om',
	'ps',
	'fa',
	'pl',
	'pt',
	'pa',
	'qu',
	'ro',
	'ru',
	'sm',
	'sa',
	'gd',
	'sr',
	'st',
	'sn',
	'sd',
	'si',
	'sk',
	'sl',
	'so',
	'es',
	'su',
	'sw',
	'sv',
	'tg',
	'ta',
	'tt',
	'te',
	'th',
	'ti',
	'ts',
	'tr',
	'tk',
	'ak',
	'uk',
	'ur',
	'ug',
	'uz',
	'vi',
	'cy',
	'xh',
	'yi',
	'yo',
	'zu',
	'he',
	// 'iw', NOTE: alternative code for Hebrew (he)
	'jv',
	// 'jw', NOTE: alternative code for Javanese (jv)
];

module.exports = {
	GOOGLE_LANGUAGES,
};
